//子级router-view承载
import Center from '@/components/common/center'

//库房管理---入库管理
import Enter from '@/pages/yikuhuanbiao/in/list'

//库存sku
import SKU from '@/pages/yikuhuanbiao/stock/sku'
//待出库
import WaitOut from '@/pages/yikuhuanbiao/stock/wait.out'
//导入出库单
import SKUImport from '@/pages/yikuhuanbiao/stock/sku.import'

//库房管理---出库管理
import Out from '@/pages/yikuhuanbiao/out/list'
//导入出库单
import ExportOut from '@/pages/yikuhuanbiao/out/export.out'
//打印网页
import PrintPage from '@/pages/yikuhuanbiao/out/print.page'

//上传快递单
import UploadExp from '@/pages/yikuhuanbiao/out/upload.express'

//==========一件代发===========//
//批次列表
import OneBatch from '@/pages/yikuhuanbiao/one/batch'
//一件代发列表
import OneList from '@/pages/yikuhuanbiao/one/list'
//导入批次
import OneImport from '@/pages/yikuhuanbiao/one/import'

//废弃管理
import Discard from '@/pages/yikuhuanbiao/discard/list'
//废弃扫描
import DiscardExport from '@/pages/yikuhuanbiao/discard/export'

export default [{
  path: '/Warehouse',
  component: Center,
  redirect: '/Warehouse/Enter',
  meta: {
    title: '移库换标'
  },
  children: [{
    path: '/Warehouse/Enter',
    component: Center,
    redirect: '/Warehouse/Enter',
    meta: {
      title: ""
    },
    children: [{
      path: '/Warehouse/Enter',
      component: Enter,
      meta: {
        title: "已入库包裹"
      },
    }]
  }, {
    path: '/Warehouse/SKU',
    component: Center,
    redirect: '/Warehouse/SKU',
    meta: {
      title: "库存SKU"
    },
    children: [{
      path: '/Warehouse/SKU',
      component: SKU,
      meta: {
        title: "库存SKU"
      },
    }, {
      path: '/Warehouse/SKU/Import',
      component: SKUImport,
      meta: {
        title: "导入SKU信息"
      },
    }]
  }, {
    path: '/Warehouse/Out',
    component: Center,
    redirect: '/Warehouse/Out',
    meta: {
      title: "出库单"
    },
    children: [{
      path: '/Warehouse/Out',
      component: Out,
      meta: {
        title: "出库单"
      },
    }, {
      path: '/Warehouse/ExportOut',
      component: ExportOut,
      meta: {
        title: "导入出库单"
      },
    }, {
      path: '/Warehouse/WaitOut',
      component: WaitOut,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/Warehouse/UploadExp',
      component: UploadExp,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/PrintPage',
      component: PrintPage,
      meta: {
        title: '打印'
      },
    }]
  }, {
    path: '/One/Batch',
    component: Center,
    redirect: '/One/Batch',
    meta: {
      title: '一件代发'
    },
    children: [{
        path: '/One/Batch',
        component: OneBatch,
        meta: {
          title: '一件代发'
        },
      },
      {
        path: '/One/OneList',
        component: OneList,
        meta: {
          title: '一件代发'
        },
      }, {
        path: '/One/OneImport',
        component: OneImport,
        meta: {
          title: '一件代发'
        },
      }
    ]
  }, {
    path: '/Warehouse/Discard',
    component: Center,
    redirect: '/Warehouse/Discard',
    meta: {
      title: "废弃整理"
    },
    children: [{
      path: '/Warehouse/Discard',
      component: Discard,
      meta: {
        title: "库存整理"
      },
    }, {
      path: '/Warehouse/DiscardExport',
      component: DiscardExport,
      meta: {
        title: "导入废弃单"
      },
    }]
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/yikuhuanbiao.js